import { render, staticRenderFns } from "./StudentAcceptedNewLessonTimeNotification.vue?vue&type=template&id=b0ecffaa&"
import script from "./StudentAcceptedNewLessonTimeNotification.vue?vue&type=script&lang=js&"
export * from "./StudentAcceptedNewLessonTimeNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports